import { getMsToNextHalfHour } from '../../../shared/date-utils';

export const MAX_DELAY_BEFORE_NEXT_LIVE_CLASS = 150000;
export const MIN_DELAY_BEFORE_NEXT_LIVE_CLASS = 10000;

export function getRandomDelay(): number {
  const msToNextHalfHour = getMsToNextHalfHour();
  const maxMs =
    msToNextHalfHour > MAX_DELAY_BEFORE_NEXT_LIVE_CLASS ? MAX_DELAY_BEFORE_NEXT_LIVE_CLASS : msToNextHalfHour;

  return Math.floor(Math.random() * (maxMs - MIN_DELAY_BEFORE_NEXT_LIVE_CLASS + 1)) + MIN_DELAY_BEFORE_NEXT_LIVE_CLASS;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/services/live-class-helpers.ts